/**
 * Seeder-aligned permission module names.
 * Must stay in sync with `Quila Backend/seeders/sidebar-permissions.constants.ts`.
 * Format: `{Module}_{Action}` — use `modulePermissionName(module, action)`.
 */
export const PERMISSION_MODULE = {
  DASHBOARD: "Dashboard",
  ROLE: "Role",
  PERMISSION: "Permission",
  USER: "User",
  APP_USER: "AppUser",
  BUSINESS_USER: "BusinessUser",
  BUSINESS: "Business",
  BUSINESS_POLICY: "BusinessPolicy",
  BOOKING: "Booking",
  PRODUCT: "Product",
  SERVICE: "Service",
  DEEPLINK: "Deeplink",
  TRANSACTION: "Transaction",
  REFUND: "Refund",
  PRODUCT_RETURN: "ProductReturn",
  CANCELLATION_POLICY: "CancellationPolicy",
  INVOICE: "Invoice",
  PAYOUT: "Payout",
  REPORTING_DASHBOARD: "ReportingDashboard",
  REPORT: "Report",
  SCHEDULED_REPORT: "ScheduledReport",
  DATA_EXPORT: "DataExport",
  EDUCATIONAL_CONTENT: "EducationalContent",
  PROMOTIONAL_CONTENT: "PromotionalContent",
  LEGAL_PAGE: "LegalPage",
  FAQ: "FAQ",
  REVIEW_QUEUE: "ReviewQueue",
  REPORTED_CONTENT: "ReportedContent",
  TICKET: "Ticket",
  FEEDBACK: "Feedback",
  HELPDESK: "Helpdesk",
  NOTIFICATION_TEMPLATE: "NotificationTemplate",
  APP_NOTIFICATION: "AppNotification",
  NOTIFICATION_LOG: "NotificationLog",
  FORM: "Form",
  FEATURE_TOGGLE: "FeatureToggle",
  ERROR_LOG: "ErrorLog",
} as const;

export type PermissionModule =
  (typeof PERMISSION_MODULE)[keyof typeof PERMISSION_MODULE];

export const PERMISSION_ACTION = {
  LIST: "List",
  ADD: "Add",
  EDIT: "Edit",
  DELETE: "Delete",
} as const;

export type PermissionAction =
  (typeof PERMISSION_ACTION)[keyof typeof PERMISSION_ACTION];
